import React from 'react';

type ISkeleton = {
    className?: string;
    height?: string | number;
}

export const Skeleton = ({ className, height }: ISkeleton) => {
    if (!height) {
        height = "10";
    }
    return (
        <div className={`animate-pulse bg-gray-200 h-${height} w-full rounded-md ${className}`}></div>
    );
}